<template>
  <div>
    <div v-if="loading">
      <b-spinner
        variant="primary"
        style="width: 3rem; height: 3rem"
        label="Large Spinner"
      ></b-spinner>
    </div>

    <b-row v-if="!loading">
      <b-col>
        <p class="text-muted"> {{ shippingManifest.reference }}</p>
        <strong v-if="shippingManifest.courier">
          {{ shippingManifest.courier.name }}</strong
        >

        <table class="table mt-3">
          <tr v-for="js in jobShippings" :key="js.id">
            <td>
              <h5 class="text-primary m-0 font-weight-bold">{{ js.job.job_number }}</h5>
              <br />
            </td>
            <td>
              <p class="m-0" v-if="js.job.imei_in">{{ js.job.imei_in }}</p>
              <p class="m-0" v-if="js.job.serial_in">{{ js.job.serial_in }}</p>
            </td>
            <td>
              <p class="m-0 font-weight-bold" v-if="js.job.manufacture">
                {{ js.job.manufacture.description }}
              </p>
              <p class="m-0" v-if="js.job.device_model.description">
                {{ js.job.device_model.description }}
              </p>
            </td>
          </tr>
        </table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import shippingManifestRepo from "@/api/repos/shippingManifestRepo";

export default {
  props: ["id"],

  mounted() {
    this.getManifest();
  },

  data() {
    return {
      isLoad: false,
      loading: false,
      shippingManifest: {},
      jobShippings: [],
      sort: { column: "created_at", label: "Date Created Asc", order: "asc" },
      sortOptions: [
        { column: "created_at", label: "Date Created Asc", order: "asc" },
        { column: "created_at", label: "Date Created Desc", order: "desc" },
      ],
      filterOptions: [],
      page: 1,
      rowsPerPage: localStorage.getItem("rowsPerPage")
        ? localStorage.getItem("rowsPerPage")
        : 10,
      fromRow: 0,
      toRow: 0,
      totalRows: 0,
      lastPage: 0,
    };
  },

  methods: {
    async getManifest() {
      try {
        this.loading = true;
        let { data } = await shippingManifestRepo.get(this.id);
        this.shippingManifest = data.shipping_manifest;
        this.jobShippings = this.shippingManifest.job_shippings;

        console.log(data);
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
